import { CommonModule } from '@angular/common';
import { Component, NgModule, OnInit } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { RouterModule } from '@angular/router';
import { Roles } from '@app/common/roles';
import { NgSubscribeModule } from '@app/directives/ng-subscribe.directive';
import { PageType } from '@app/models/page';
import { SecurityService } from '@app/services/security.service';
import { Observable } from 'rxjs';
import { PageCenterModule } from '../page-center/page-center.component';

@Component({
  selector: 'app-content-page-center-view',
  templateUrl: './content-page-center-view.component.html',
  styleUrls: ['./content-page-center-view.component.scss']
})
export class ContentPageCenterViewComponent implements OnInit {

  allowedToCreateNew$: Observable<boolean>;
  pageType: PageType = PageType.Content;

  constructor(private securityService: SecurityService) { }

  ngOnInit() {
    this.allowedToCreateNew$ = this.securityService.hasUserAnyAppRole([Roles.Admin, Roles.Editor]);
  }
}
@NgModule({
  declarations: [
    ContentPageCenterViewComponent
  ],
  exports: [
    ContentPageCenterViewComponent
  ],
  imports: [
    MatButtonModule,
    CommonModule,
    RouterModule,
    PageCenterModule,
    NgSubscribeModule
  ]
})
export class ContentPageCenterViewModule { }
